import {Doctor} from "../types/Doctor";

type GetTabValue = (doctor: Doctor) => string;

const getTabValue: GetTabValue = (doctor) =>
    (doctor.availableDates.length > 0)
        ? `${doctor.availableDates[0].dayOfRecipient.toString()}|${doctor.id}`
        : ''

export default getTabValue;